import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, InputBase, MenuItem, TextField } from "@mui/material";
import { AddCircle as AddCircleIcon, RemoveCircle as RemoveCircleIcon } from "@mui/icons-material";

import HelpIcon from "@mui/icons-material/Help";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import { SiTiktok } from "react-icons/si";
import FacebookIcon from "../../../assets/icons/FacebookIcon";
import XIcon from "@mui/icons-material/X";
import { darkGray, darkRed, lightGreen } from "../../../constants/colors";

import useStyles from "./style";

const socialData = [
  {
    value: "facebook",
    label: "Facebook",
    icon: <FacebookIcon style={{ color: "#525252" }} />,
    url: "",
  },
  {
    value: "twitter",
    label: "X",
    icon: <XIcon />,
    url: "",
  },
  {
    value: "youtube",
    label: "Youtube",
    icon: <YouTubeIcon style={{ color: "#FF0000" }} />,
    url: "",
  },
  {
    value: "instagram",
    label: "Instagram",
    icon: <InstagramIcon style={{ color: "#CF1F4E" }} />,
    url: "",
  },
  {
    value: "tiktok",
    label: "TikTok",
    icon: <SiTiktok style={{ color: "#240D1C" }} />,
    url: "",
  },
  {
    value: "linkedin",
    label: "LinkedIn",
    icon: <LinkedInIcon style={{ color: "#0177B5" }} />,
    url: "",
  },
  {
    value: "other_social_type",
    label: "Other",
    icon: <HelpIcon style={{ color: "#525252" }} />,
    url: "",
  },
];

export default function SocialMediaInput({ formik, style = {}, containerStyle = {}, height = 40 }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [selectedSocialData, setSelectedSocialData] = useState(formik.values.socialData);

  useEffect(() => {
    formik.setFieldValue("socialData", selectedSocialData);
  }, [selectedSocialData]);

  useEffect(() => {
    if (Object.keys(formik.errors).includes("socialData")) {
      const reg = new RegExp(
        /((https?):\/\/)(www.)[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      );
      const newElements = selectedSocialData.map((ele) => {
        if (!reg.test(ele.url)) {
          return { ...ele, error: "Enter correct url!!!" };
        }
        return ele;
      });
      setSelectedSocialData(newElements);
    }
  }, [formik.errors]);

  const handleAddSocial = (index) => {
    if (index < socialData.length) {
      const remaining = socialData.filter(
        (ele) => !selectedSocialData.some((e) => e.value === ele.value),
      );
      setSelectedSocialData([...selectedSocialData, remaining[0]]);
    }
  };

  const handleRemoveSocial = (index) => {
    const newOptions = [...selectedSocialData];
    newOptions.splice(index, 1);
    setSelectedSocialData(newOptions);
  };

  return (
    <div style={style}>
      {selectedSocialData?.length &&
        selectedSocialData.map((element, index) => (
          <div
            style={{
              marginBottom: index < selectedSocialData.length - 1 ? 18 : 0,
            }}
            key={element.value}
          >
            <div
              className={classes.socialMediaContainer}
              style={{
                ...containerStyle,
                borderColor:
                  formik.errors.socialData && formik.errors.socialData[index] ? darkRed : undefined,
                height,
              }}
            >
              <TextField
                id="standard-select-social-native"
                variant="outlined"
                select
                label=""
                classes={{
                  root: classes.textField,
                  // input: classes.autoCompleteInput,
                }}
                value={element.value}
                onChange={(e) => {
                  const { value } = e.target;
                  const item = socialData.filter((ele) => ele.value === value)[0];
                  const newElements = selectedSocialData.map((ele) =>
                    ele.value === element.value ? { ...item, url: element.url } : ele,
                  );
                  setSelectedSocialData(newElements);
                }}
                SelectProps={{
                  renderValue: () =>
                    element?.icon || socialData.find((el) => el?.value === element?.value)?.icon,
                }}
              >
                {socialData
                  .filter((item) => !selectedSocialData.some((el) => el.value === item.value))
                  .map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.icon}
                    </MenuItem>
                  ))}
              </TextField>
              <InputBase
                style={{ paddingLeft: 8, margin: 0, width: "100%" }}
                placeholder={`${element.label} URL`}
                name={`socialData.${index}.url`}
                id={`socialData.${index}.url`}
                error={
                  !!(
                    formik.errors.socialData &&
                    formik.errors.socialData[index] &&
                    formik.errors.socialData[index].url
                  )
                }
                helperText={
                  formik.errors.socialData &&
                  formik.errors.socialData[index] &&
                  formik.errors.socialData[index].url
                    ? formik.errors.socialData[index].url
                    : ""
                }
                onChange={(e) => {
                  const newOptions = [...selectedSocialData];
                  newOptions[index].url = e.target.value;
                  setSelectedSocialData(newOptions);
                  formik.setFieldValue(`socialData.${index}.url`, e.target.value);
                }}
                value={element.url}
              />
              {index === selectedSocialData.length - 1 && index !== socialData.length - 1 && (
                <IconButton onClick={handleAddSocial.bind(this, index)}>
                  <AddCircleIcon className={classes.addIcon} style={{ color: lightGreen }} />
                </IconButton>
              )}
              {(index < selectedSocialData.length - 1 || index === socialData.length - 1) && (
                <IconButton
                  onClick={() => {
                    formik.setFieldValue(`socialData.${index}.url`, "");
                    handleRemoveSocial(index);
                  }}
                >
                  <RemoveCircleIcon className={classes.removeIcon} />
                </IconButton>
              )}
            </div>
            {formik.errors.socialData &&
              formik.errors.socialData[index] &&
              formik.errors.socialData[index].url && (
                <div className={classes.helperTextContainer}>
                  <p className={classes.helperText}>{formik.errors.socialData[index].url}</p>
                </div>
              )}
          </div>
        ))}
    </div>
  );
}
